import { render } from "./notWinning.vue?vue&type=template&id=7c0cd724&scoped=true"
import script from "./notWinning.vue?vue&type=script&lang=js"
export * from "./notWinning.vue?vue&type=script&lang=js"

import "./notWinning.vue?vue&type=style&index=0&id=7c0cd724&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0cd724"]])

export default __exports__